
import createIconComponent from '../utils/createIconComponent';
import { SVG_VISA_LIGHT_MODE } from '../../../dist';
import React from 'react';
const VisaLightModeIcon = createIconComponent({ content: SVG_VISA_LIGHT_MODE, height: 24, width: 60 });
VisaLightModeIcon.displayName = 'VisaLightModeIcon';
export default VisaLightModeIcon;
